<template>
   <div id="block_content_wrapper">

      <!-- Program Block Assets -->
      <div class="block-assets-wrapper">
         <block-assets>
            <slot name="assets">
            </slot>
         </block-assets>
      </div>

      <!-- Right Area -->
      <div class="block-right-col no-padding">
      
         <!-- <expiration-info
            :on="block.c_exp_date != '' && block.c_exp_date != undefined"
            :expDate="block.c_exp_date"
            :expTime="block.c_exp_time"
            @changeExp="updateExp"
         ></expiration-info> -->

         <channel-checks
            :channelRecid="recid == -1 ? activeChannelRecid : ''"
            :initialSelected="channels"
         ></channel-checks>
         
         <category-checks
            :initialSelected="categories"
         ></category-checks>
         
      </div>

      <div class="block-space">
      </div>

   </div>
</template>

<script>
import BlockAssets from './BlockAssets';

import ChannelChecks from '@/global/ChannelChecks';
import CategoryChecks from '@/global/CategoryChecks';

export default {
   props: {
      recid: {
         required: true,
         type: Number | String
      },
      activeChannelRecid: {
         required: false,
         type: Number | String,
         default: ''
      },
      channels: {
         required: true,
         type: Array
      },
      categories: {
         required: true,
         type: Array
      }
   },

   components: {
      ChannelChecks,
      CategoryChecks
   }
}
</script>


<style lang="scss" scoped>

#block_content_wrapper {
   margin-bottom: 45px;
   display: flex;
}

.block-right-col {
   width: 24%;
   >div:not(:last-child) {
      margin-bottom: 20px;
   }
}

.block-assets-wrapper {
   margin-right: 15px;
   width: 75%;
}

</style>